// extracted by mini-css-extract-plugin
export default {"paper":"paper_paper__aOwjC","paper--in-modal":"paper_paper--in-modal__G+F47"};